<template>
    <div>
        <div class="title__rank">
            <span v-html="t.activate_crm_title"></span>
            <!-- <span class="badge-forecast" v-text="t.new"></span> -->
            <span class="helper__tooltip white icon__title">
                <span class="helper__tooltip--text" v-html="t.activate_crm_tooltip"></span>
            </span>
            
        </div>
        <div class="activate_crm card-v4">
            <span>{{t.activate_crm_value_label}}</span>
            <div data-toggle="tooltip" data-placement="bottom" class="sliderWrapper">
                <input id="cheetah_va" type="checkbox" class="customSlider" v-model="checkbox" @change="handleCRM()">
                <!-- <label for="cheetah_va" data-text="ATIVO           INATIVO"></label> -->
                <label for="cheetah_va" :data-text="activeInactiveText"></label>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";

export default {
    name: "activate-crm",
    components: {},
    data() {
        return {
            t: this.$parent.view.translation.activateCRM,
            values: this.$parent.view.forecast_comissions,
            activeInactiveText: this.$parent.view.translation.activateCRM['activate_crm_active_inactive'],
            checkbox: null
        };
    },
    methods: {
        handleCRM() {
            let vm = this;
            axios
            .post(
                vm.$parent.view.propsNewIndex.routes.rota_office_handle_crm_ativation,
                qs.stringify({ handleCRM: vm.checkbox })
            )
            .then(function(resposta) {
                alertMsg(resposta.data.status, resposta.data.msg)
            })
            .catch(function(error) {
                alertMsg('error', 'Network Error');
            })
        }
    }
};
</script>
<style scoped lang="scss">
.title__rank {

    align-items: center;
    padding: 0.5rem 2.5rem;
    margin-top: 1rem;
    .badge-forecast {
        padding: 3px 12px;
        background: #fff;
        margin-left: 15px;
        border-radius: 37px;
        font-size: 0.9rem;
        font-weight: bold;
        color: #7400fc;
        font-weight: bold;
    }
}
.activate_crm {
    display: flex;
    justify-content: space-around;
    span {
        font-weight: bold;
        color: #979797;
    }
    .sliderWrapper .customSlider+label:before {
        width: 150px;
        height: 28px;
        top: -13px;
        border-color: #dadada;
        background: #dadada;
        color: white;
        padding-top: 7px;
        padding-left: 5px;
        white-space: pre;
        // content: 'ATIVO\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0INATIVO';
        // content: var(--tActiveInactive);
        text-transform: uppercase;
        content: attr(data-text);
        font-size: 13px;
    }
    .sliderWrapper .customSlider+label:after {
        height: 26px;
        width: 80px;
        top: -12px;
        left: 0px;
        border-radius: 19px;
        border-color: #979797;
        background: #979797;
    }
    .sliderWrapper .customSlider:checked+label:after {
        left: 70px;
    }
    @media only screen and (max-width: 992px) {
        flex-direction: column;
        div.separator {
            display: none;
        }
    }
}
.helper__tooltip--text {
    width: 170px;
    top: 25px;
}
.helper__tooltip:after {
    top: -8px;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/activateCRM.vue